export function getToCforTag() {
  throw new Error('getToCforTag called on the client!');
}

export function getToCforMultiDocument() {
  throw new Error('getToCforMultiDocument called on the client!');
}

export function getToCforPost() {
  throw new Error('getToCforPost called on the client!');
}
